var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertCircleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "alert-circle-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#alert-circle-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.989.002a8.14 8.14 0 0 0-5.673 2.435A7.87 7.87 0 0 0 .001 8.139a7.85 7.85 0 0 0 7.866 7.862h.143A8.073 8.073 0 0 0 16 7.86 7.844 7.844 0 0 0 7.99.002M7 11.029a.983.983 0 0 1 .966-1.02h.018a1.02 1.02 0 0 1 1.016.98.983.983 0 0 1-.966 1.02h-.018A1.02 1.02 0 0 1 7 11.029m.334-2.695v-4a.667.667 0 0 1 1.333 0v4a.667.667 0 1 1-1.333 0"
}))));
export { SvgAlertCircleIcon as ReactComponent };
export default __webpack_public_path__ + "0a91772302b5dc7bf47dc9af05eb2e69.svg";